export default __webpack_public_path__ + "static/robot-dbe71fd53f7441d13e9bcc49f032e6b2.jpg";